import { render, staticRenderFns } from "./ResultSingle2.vue?vue&type=template&id=2f560c40&scoped=true&"
import script from "./ResultSingle2.vue?vue&type=script&lang=js&"
export * from "./ResultSingle2.vue?vue&type=script&lang=js&"
import style0 from "./ResultSingle2.vue?vue&type=style&index=0&id=2f560c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f560c40",
  null
  
)

export default component.exports